export default __webpack_public_path__ + "static/media/Arrow-gray.ab608981.svg";